import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

const KEY = "imaginary_consent"; // "all" | "essential"

export default function CookieBanner() {
  const { lang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (v) => {
    try {
      localStorage.setItem(KEY, v);
    } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[70] border-t border-[#111111]/12 bg-[#faf8f5] px-6 py-5 md:px-12"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="max-w-2xl text-xs font-light leading-relaxed text-[#111111]/70">
          {lang === "fr"
            ? "Nous utilisons uniquement des cookies essentiels (panier, langue). Les cookies de mesure d'audience sont désactivés par défaut et ne seront déposés qu'avec votre accord."
            : "We only use essential cookies (cart, language). Analytics cookies are off by default and will only be set with your consent."}{" "}
          <Link to="/legal/cookies" className="link-underline">
            {lang === "fr" ? "En savoir plus" : "Learn more"}
          </Link>
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            onClick={() => choose("essential")}
            data-testid="cookie-essential"
            className="border border-[#111111]/30 px-5 py-2.5 text-xs font-light text-[#111111] transition-colors duration-300 hover:border-[#111111]"
          >
            {lang === "fr" ? "Essentiels uniquement" : "Essential only"}
          </button>
          <button
            onClick={() => choose("all")}
            data-testid="cookie-accept"
            className="bg-[#111111] px-5 py-2.5 text-xs font-light text-[#faf8f5] transition-opacity duration-300 hover:opacity-85"
          >
            {lang === "fr" ? "Tout accepter" : "Accept all"}
          </button>
        </div>
      </div>
    </div>
  );
}
